import React, { useEffect, useState } from 'react';

export default function App() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/products')
      .then(res => res.json())
      .then(data => {
        setProducts(data);
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="flex h-screen items-center justify-center font-bold text-indigo-600">Loading Store...</div>;

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <nav className="bg-white shadow-sm py-4 px-10 flex justify-between items-center sticky top-0 z-50">
        <h1 className="text-2xl font-black text-indigo-600">D1-EXPRESS</h1>
        <div className="space-x-8 hidden md:flex font-medium text-gray-600">
          <a href="#" className="hover:text-indigo-600">New</a>
          <a href="#" className="hover:text-indigo-600">Shop</a>
          <a href="#" className="hover:text-indigo-600">Contact</a>
        </div>
        <button className="bg-gray-900 text-white px-5 py-2 rounded-full text-sm font-bold">Cart (0)</button>
      </nav>

      {/* Hero Section */}
      <header className="bg-indigo-700 h-[400px] relative overflow-hidden flex items-center justify-center">
        <img src="https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=1200" className="absolute w-full h-full object-cover opacity-30" alt="Hero" />
        <div className="relative text-center text-white px-4">
          <h2 className="text-5xl font-extrabold mb-4 uppercase italic">Premium Essentials</h2>
          <p className="text-lg opacity-90 max-w-lg mx-auto">High-performance gear stored in Cloudflare D1 and delivered at the edge.</p>
          <button className="mt-8 bg-white text-indigo-700 px-8 py-3 font-bold rounded hover:scale-105 transition">Shop The Drop</button>
        </div>
      </header>

      {/* Product Grid */}
      <main className="max-w-7xl mx-auto px-10 py-16">
        <h3 className="text-3xl font-bold mb-10 text-gray-900">Featured Products</h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {products.map((p) => (
            <div key={p.id} className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all border border-gray-100 group">
              <div className="h-72 bg-gray-200 overflow-hidden relative">
                <img 
                  src={p.image_url || 'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=500'} 
                  className="w-full h-full object-cover group-hover:scale-110 transition duration-500" 
                  alt={p.name} 
                />
                <span className="absolute top-4 right-4 bg-white/90 backdrop-blur px-3 py-1 rounded-full text-xs font-bold">${p.price}</span>
              </div>
              <div className="p-6">
                <span className="text-[10px] font-bold text-indigo-500 uppercase tracking-widest">{p.category || 'Collection'}</span>
                <h4 className="text-xl font-bold mt-1 text-gray-900">{p.name}</h4>
                <p className="text-gray-500 text-sm mt-2 line-clamp-2">{p.description}</p>
                <button className="mt-6 w-full bg-gray-900 text-white py-3 rounded-xl font-bold hover:bg-indigo-600 transition">Quick Add +</button>
              </div>
            </div>
          ))}
        </div>
      </main>

      <footer className="py-10 text-center text-gray-400 text-xs border-t">
        © 2026 D1-EXPRESS | Hosted on Cloudflare Pages
      </footer>
      <langflow-chat window_title="MT RAG" flow_id="f6df10ee-3ae4-4362-8cb2-a3c11ab70dc3"
      host_url="https://langflowailangflowlatest-production-f841.up.railway.app" 
      class="langflow-chat-fixed"
      chat_position="bottom-right" width="360" height="520" 
      chat_window_style='{
       "position": "fixed",
        "right": "10px",
        "bottom": "58px",
        "width": "90vw",
        "height": "60vh",
        "maxWidth": "clamp(270px, 30vw, 360px)",
         "maxHeight": "clamp(420px, 60vh, 520px)",
         "borderRadius": "18px"}' 
      api_key="sk-jAGsVShxxAHq3da-kFE9O5thlJF-dQNMEAD5M0PSKqU">
  </langflow-chat>
    </div>
  );
}